
{
  "labels": {
    "success": "Copied value to clipboard",
    "error": "Unable to copy to clipboard"
  }
}
